import type { ReactNode } from "react";

interface TileCardProps {
  label: string;
  accent?: "amber" | null;
  children: ReactNode;
  testId?: string;
}

export function TileCard({
  label,
  accent = null,
  children,
  testId,
}: TileCardProps) {
  const className =
    "tile" + (accent === "amber" ? " tile--accent-amber" : "");
  return (
    <section className={className} data-testid={testId}>
      <div className="tile-label">{label}</div>
      {children}
    </section>
  );
}
